import { default as config } from "common/config/config";
import { useQuery } from "react-query";
import type { UseQueryResult } from "react-query";
import type { PaginatedUsersDto } from "common/models/api/models/PaginatedUsersDto";
import type { RoleDto } from "common/models/api/models/RoleDto";
import { RoleType } from "common/models/role/Role";
import useUserState from "ui/adapter/state/useUserState";
import { Queries } from "ui/query/queries";
import type { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { usersApi } from "../api/usersApi";

export type UseGetUsersOptions = {
    query?: string;
    pageSize?: number;
    page: number;
    order?: "ASC" | "DESC";
    orderBy?: string;
    roleFilter?: "organization-owner" | "operation-manager" | "program-manager" | "partner" | "customer-service";
};

export default function useUsersFindAll(
    { query, pageSize = config.paginatedPageSizes.users, page, order, orderBy, roleFilter }: Partial<UseGetUsersOptions> = {
        page: 1,
        pageSize: 100,
        order: "DESC",
    },
    {
        enabled = true,
        ...options
    }: UseCustomQueryOptions<PaginatedUsersDto, unknown, PaginatedUsersDto, (string | undefined | number | RoleDto)[]> = {},
): UseQueryResult<PaginatedUsersDto> {
    const { selectedRole } = useUserState();
    return useQuery(
        [Queries.USER_FIND_ALL, query, page, pageSize, order, orderBy, selectedRole, roleFilter],
        async () => {
            const res = await usersApi.findAll({ page, pageSize, query, order, orderBy, roleFilter });
            return res.data;
        },
        { enabled: enabled && selectedRole?.roleType !== RoleType.PARTNER, ...options },
    );
}
